import type { QueryClient } from '@tanstack/vue-query'

export const queryClient = (): QueryClient => useNuxtApp().$queryClient
